import React, { useState } from 'react'

import {
  FadeIn,
  Button,
  HeadingMedium,
  HeadingSmall,
  BodyText,
  LayoutContainer,
  IntersectionVisible,
} from '@pb/components'
import { getLabelFromStorage, getLocale, isOtherStoriesBrand } from '@pb/utils'
import cn from 'classnames'
import { useDispatch } from 'react-redux'
import { EXTERNAL_ROUTES } from 'App/constants'
import {  operationViewFavouritesEmpty } from 'features/favourites/duck/operations'
import { trackClickFavouritesEmpty, trackViewFavouritesEmptyButton } from '../../tracking'

import styles from './FavouritesEmpty.scss'

type FavouritesEmptyProps = {
  isSmall?: boolean
}

const FavouritesEmpty: React.FC<FavouritesEmptyProps> = ({ isSmall = false }) => {
  const dispatch = useDispatch()
  const [isFavouritesEmptyPageViewed, setFavouritesEmptyPageViewed] = useState<boolean>(false)
  const [isFavouritesEmptyButtonViewed, setFavouritesEmptyButtonViewed] = useState<boolean>(false)

  const onButtonClick = (): void => {
    isOtherStoriesBrand ? trackClickFavouritesEmpty() : null 
    isOtherStoriesBrand && getLocale() === 'en_usd' ? window.location.href = EXTERNAL_ROUTES.newArrivalsOtherStories : window.location.href = EXTERNAL_ROUTES.index 
  }

  const handleInView = (): void => {
    setFavouritesEmptyPageViewed(true)
    if (isOtherStoriesBrand) {
      dispatch(operationViewFavouritesEmpty())
    }
  }

  const handleInViewButton = (): void => {
    setFavouritesEmptyButtonViewed(true)
    if (isOtherStoriesBrand) {
      trackViewFavouritesEmptyButton()
    }
  }

  const isReduceSpacing =
    process.env.IS_REDUCE_SPACING_FAVOURITE_EMPTY_CONTAINER_ENABLED === 'enabled'

  const isShoppingBtnExtraSpace =
    process.env.IS_EMPTY_FAVORITES_BUTTON_EXTRA_SPACING_ENABLED === 'enabled'

  const isHeadingMedium = process.env.IS_EMPTY_FAVOURITES_HEADING_MEDIUM_ENABLED === 'enabled'

  const isFavouritesEmptyHeadingEnabled =
    process.env.IS_FAVOURITES_EMPTY_HEADING_ENABLED === 'enabled'
  return (
    <FadeIn>
      <IntersectionVisible onShow={() => handleInViewButton()} active={!isFavouritesEmptyPageViewed} options={{threshold: 1.0}}>
        <LayoutContainer
          className={cn(
            styles.container,
            isReduceSpacing && styles.reduceExtraSpacing,
            isSmall && styles.smallPadding,
          )}
        >
          {isHeadingMedium && isFavouritesEmptyHeadingEnabled ? (
            <HeadingMedium Tag="h2" className={styles.heading}>
              {getLabelFromStorage('favorites.empty.heading')}
            </HeadingMedium>
          ) : (
            isFavouritesEmptyHeadingEnabled && (
              <HeadingSmall Tag="h2" className={styles.heading}>
                {getLabelFromStorage('favorites.empty.heading')}
              </HeadingSmall>
            )
          )}
          <BodyText>{getLabelFromStorage('favorites.empty.text')}</BodyText>
          <LayoutContainer
            className={cn(isSmall ? styles.smallButtonContainer : styles.buttonContainer)}
          >
            <IntersectionVisible onShow={() => handleInView()} active={!isFavouritesEmptyButtonViewed} options={{threshold: 1.0}}>
              <Button
                className={cn(isShoppingBtnExtraSpace && styles.shoppingBtnExtraSpace)}
                onClick={onButtonClick}
                fullWidth={isSmall}
              >
                {getLabelFromStorage('favorites.empty.browsing')}
              </Button>
            </IntersectionVisible>
          </LayoutContainer>
        </LayoutContainer>
      </IntersectionVisible>
    </FadeIn>
  )
}

export default React.memo(FavouritesEmpty)
